import { render, staticRenderFns } from "./suvivors.vue?vue&type=template&id=45590239&scoped=true&"
import script from "./suvivors.vue?vue&type=script&lang=js&"
export * from "./suvivors.vue?vue&type=script&lang=js&"
import style0 from "./suvivors.vue?vue&type=style&index=0&id=45590239&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45590239",
  null
  
)

export default component.exports